import { getConceptCobfigurationByConcept } from '@cbgms/api/support/conceptConfiguration/apis'
import { useQuery } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'

export function useGetConceptConfigurationByConcept(concept: string) {
  const dispatch = useDispatch()

  return useQuery({
    enabled: concept !== undefined || concept !== '',
    queryKey: ['get-concept-config', concept],
    queryFn: async () => {
      if (concept === undefined) {
        return undefined
      }
      const { Data } = await dispatch(getConceptCobfigurationByConcept(concept))

      return Data
    },
    refetchOnWindowFocus: false
  })
}
